<template>
  <mtd-dropdown style="padding: 0 5px" trigger="click" placement="bottom">
    <mtd-popover trigger="hover">
      <div class="time">
        <span class="time-text">{{
          title +
          " " +
          titleTime
        }}</span>
        <mtd-icon name="mtdicon-down-thick" class="time-icon" />
      </div>
      <template #content>
        <div>
          {{
            title +
            " " +
            titleTime
          }}
        </div>
      </template>
    </mtd-popover>
    <template #dropdown>
      <mtd-dropdown-menu>
        <mtd-dropdown-menu-item
          v-for="item in regionList"
          :key="item.code"
          :command="item"
          @click="onCommand(item)"
        >
          <div :class="{ selected: item.code === region.code, 'dropdown-item': true }">
            <span class="label">{{ item.name }}</span
            >
            <mtd-icon
              v-if="item.code === region.code"
              name="mtdicon-check"
              class="check"
            ></mtd-icon>
          </div>
        </mtd-dropdown-menu-item>
      </mtd-dropdown-menu>
    </template>
  </mtd-dropdown>
</template>
<script>
import { MDateTime, MCity } from "@sailor/i18n-vue";
import { RegionReader, RegionUpdater, UrlHelper } from '@osgfe/web-region-store';

export default {
  inject: ['$$event'],
  data() {
    const initTime = new Date().getTime();
    return {
      region: { code: '', name: '', names: [] },
      regionList: [],
      cityId: "",
      locale: RegionReader.getCurLang(false)?.code || 'en',
      time: initTime,
    };
  },
  computed: {
    titleTime() {
      return MDateTime.formatByCityId(
        this.cityId,
        this.time,
        -1,
        2,
        this.locale
      );
    },
    title() {
      // 根据当前语言从 names 数组取本地化名称，找不到时降级到默认 name（英文）
      const names = this.region.names || [];
      const matched = names.find((n) => n.lang === this.locale) || names.find((n) => n.lang === this.locale.split('-')[0]);
      return (matched && matched.name) || this.region.name || '';
    },
  },
  created() {
    // 监听 RegionStore 就绪事件
    if (this.$$event) {
        this.$$event.$on('regionStoreReady', this.initData);
    }
  },
  mounted() {
    setInterval(() => {
      this.time = new Date().getTime();
    }, 1000);

    // 兜底：若 regionStoreReady 已在组件挂载前 emit（RegionStore 已有数据），则主动初始化
    const curRegion = RegionReader.getCurRegion(false);
    if (curRegion && curRegion.code) {
      this.initData();
    }
  },
  methods: {
    initData() {
      // 使用 RegionReader 统一读取当前 region 和 region 列表
      const curRegion = RegionReader.getCurRegion(false);
      const regionOptions = RegionReader.getRegionOptions();

      this.regionList = regionOptions && regionOptions.length > 0 ? regionOptions : [];
      this.locale = RegionReader.getCurLang(false)?.code;

      const initCity = MCity.getCapitalCityIdByRegion(curRegion.code);
      this.region = curRegion;
      this.cityId = initCity;
    },
    onCommand(regionItem) {
      // 使用 RegionUpdater 统一更新 region（自动联动语言 + 持久化到 localStorage + sessionStorage）
      RegionUpdater.updateRegionPacks(
        { curRegion: { code: regionItem.code, name: regionItem.name } },
        { syncLocalStorage: true, notifyI18nClient: true },
      );

      UrlHelper.clearParams();

      // 刷新页面使新 region/lang 生效
      window.location.reload();
    },

  },
};
</script>
<style lang="scss" scoped>
.time {
  color: #111925;
  cursor: pointer;
  margin-inline-end: 24px;

  .time-text {
    margin-inline-end: 4px;
  }

  .time-icon {
    font-size: 18px;
    vertical-align: middle;
  }
}

.time-dropdown {
  width: 200px;

  .dropdown-item {
    display: flex;
    align-items: center;

    .label {
      flex: 1;
    }
  }
}
.selected {
  color: #00b85c;
  font-weight: 700;
}
.check {
  margin-left: 10px;
}
</style>